import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";
import toast from "react-hot-toast";

const fetchServerInfo = async () => {
    const { data } = await internalApi.get("server_info");
    return data;
}

export const useServerInfo = () => {
    return useQueryBase('serverInfo', fetchServerInfo, {staleTime: 0});
}

const saveServerInfo = async (serverInfo) => {
    await internalApi.post("server_info", {serverInfo});
}

export const useSaveServerInfo = () => {
    return useMutationBase('serverInfo', saveServerInfo);
}

export const serverInfoReload = async () => {
    const res = await internalApi.post('/server_info/reload', { });
    toast.success(res.data.message);
    return res.data.reloadTime;
}

export const kickAll = async (kickIndex) => {
    const res = await internalApi.put('/server_info/kickAll', { kickIndex });
    toast.success(res.data.message)
}

export const gameDataReload = async () => {
    const res = await internalApi.post('/server_info/reload/gameData', { });
    toast.success(res.data.message);
    return res.data.reloadTime;
}

const fetchReloadTime = async () => {
    const { data } = await internalApi.get("server_info/reloadTime");
    return data.rows;
}

export const useReloadTime = () => {
    return useQueryBase('reloadTime', fetchReloadTime, {staleTime: 0});
}